import { Injectable } from "@angular/core";
import { PromptSdk } from "../sdks/prompt.sdk";
import { EMPTY, Observable, of, switchMap } from "rxjs";
import { Prompt } from "../models/prompt.model";

@Injectable({
	providedIn: 'root'
})
export class PromptManager {

	constructor(private promptSdk: PromptSdk) {
	}

	public getPrompts(searchTerm?: string): Observable<Prompt[] | null> {
		return this.promptSdk.getPrompts(searchTerm).pipe(switchMap((data) => {
			if (data)
				return of(data);
			return EMPTY;
		}));
	}
}
